import { apiMiddleware } from 'redux-api-middleware';
import authHeaderMiddleware from './authHeaderMiddleware';
import createClientContextMiddleware from './createClientContextMiddleware';
import createParamReplaceMiddleware from './createParamReplaceMiddleware';
import staticHeaderMiddleware from './staticHeaderMiddleware';
import stubMiddleware from './stubMiddleware';
import { selectors as configSelectors } from '../config';

const clientContext = {
  env: {
    platform: window.navigator.platform
  },
  client: {
    // TODO: this version should be inserted during build,
    // i.e. through config or webpack env parameters
    app_version_code: '1',
    app_title: 'Bus Account Open',
    app_version_name: navigator.appName
  }
};

const urlSelectors = {
  ':api_base_url': configSelectors.apiBaseUrlLiberty,
  ':api_paas_url': configSelectors.apiBaseUrlPaas,
  ':bank_id': configSelectors.bankId
};

export default [
  createParamReplaceMiddleware(urlSelectors),
  authHeaderMiddleware,
  createClientContextMiddleware(clientContext),
  staticHeaderMiddleware,
  stubMiddleware,
  apiMiddleware
];
